export default "__VITE_ASSET__BWSuTn9m__"